import styled from 'styled-components'
import { ColumnCenter, AutoColumn } from '../../Column'

export const Wrapper = styled.div`
  margin: 0;
  width: 100%;
`
export const ConfirmedIcon = styled(ColumnCenter)`
  padding: 60px 0;
`

export const Section = styled(AutoColumn)`
  padding: 24px;
`